<template>
  <el-dialog :title="$t('newMarket')" :visible="isShowDialog" @close="onClosePopupButtonClick()" width="300px">
    <div id="modal-body">
      <el-select v-model="selectedMarketId"
                 :placeholder="$t('pleaseSelectMarket')"
                 filterable
                 style="width: 100%;">
        <el-option
          v-for="(market, index) in marketList"
          :key="index"
          :label="((market.isEnable === STATUS.ENABLE) ? market.name : `[${$t('STATUS.DISABLE')}] ${market.name}`)"
          :value="market.id"></el-option>
      </el-select>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onAddButtonClick()" :disabled="selectedMarketId === ''">{{ $t('add') }}</el-button>
        <el-button type="default" @click="onCancelButtonClick()">{{ $t('cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Agent/components/PopupMarketList.i18n'

export default {
  name: 'PopupMarketList',
  mixins: [],
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedMarketIdList: {
      type: Array,
      default: function () {
        return []
      }
    },
    marketList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      STATUS,
      isShowDialog: false,
      selectedMarketId: ''
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    }
  },
  methods: {
    onClosePopupButtonClick: function () {
      this._closePopup()
    },
    onCancelButtonClick: function () {
      this._closePopup()
    },
    onAddButtonClick: function () {
      this.isShowDialog = false
      this.$emit('onAddMarket', this.selectedMarketId)
    },
    _closePopup: function () {
      this.isShowDialog = false
      this.selectedMarketId = ''
      this.$emit('onClose')
    }
  }
}
</script>
